import React, { FC, useMemo, useState } from "react"
import { DatePicker, Empty, Image, InfiniteScroll, SafeArea, Toast } from "antd-mobile"
import styles from "./index.module.less"
import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { useGetWelfareRid } from "~src/hooks/useGetWelfareRid"
import useQuery from "~src/hooks/useQuery"
import { WelfareMoldTyp, WelfareParticipationType } from "~src/service/welfare/welfare"
import { getParticipationRecord } from "~src/service/welfare"
import { walfare_records_1, walfare_records_2, walfare_records_3, arrow_right_gray_icon } from "~src/constants/network"
import classnames from "classnames"
import dayjs from "dayjs"
import { useNavigate } from "react-router-dom"

type ChangeType = "all" | "own"
interface ConfigType {
  page: number,
  pageSize: number,
  time: string,
  changeType: ChangeType,
  total: number
}
interface WelfareColorType {
  color: string
  titleColor: string
  bottomSrc: string
}
type WelfareDetailsColorType = Record<WelfareMoldTyp, WelfareColorType>
type PickerDate = Date & {
  tillNow?: boolean
}
const Participant: FC = () => {
  const [rid, setRid] = useState<string>("")
  const searchQuery = useQuery()
  const spuId = searchQuery("spuId")
  const skuId = searchQuery("skuId")
  const categoryId = searchQuery("categoryId")
  const projectName = searchQuery("name")
  const [tabVal, setTabVal] = useState<string>('all')
  const [hasMore, setHasMore] = useState<boolean>(false)
  const [dataList, setDataList] = useState<WelfareParticipationType[]>([])
  const [viewTime, setViewTime] = useState<PickerDate>(new Date());
  const [pickerVisible, setPickerVisible] = useState<boolean>(false);
  const [config, setConfig] = useState<ConfigType>({ page: 1, pageSize: 15, time: dayjs().format('YYYY-MM'), changeType: "all", total: 0 })
  const navigate = useNavigate()

  useDocumentTitle('参与记录')

  useGetWelfareRid((rid) => {
    setRid(() => rid)
    getRecordData(rid, 'init', dayjs().format('YYYY-MM'), 'all')
  }, [])

  const minDate = useMemo(() => {
    const last = dayjs(dayjs().subtract(5, 'month')).format('YYYY-MM-DD')
    return new Date(last)
  }, [])
  const WelfareColor: WelfareDetailsColorType = useMemo(() => {
    return {
      "1": {
        titleColor: '#26824D',
        color: "#23D85A",
        bottomSrc: walfare_records_2
      },
      "2": {
        titleColor: '#3B8BFF',
        color: "#3B8BFF",
        bottomSrc: walfare_records_1
      },
      "3": {
        titleColor: '#F7D441',
        color: "#F7D441",
        bottomSrc: walfare_records_3
      }
    }
  }, [])

  const getRecordData = async (rid: string, type: string, time = config.time, filterVal = config.changeType) => {
    const configval = {
      ...config,
      time: time,
      changeType: filterVal,
    }
    configval.page = type === 'init' ? 1 : configval.page + 1
    setConfig(() => configval)
    const ccof = {
      skuId: skuId,
      status: configval.changeType === 'all' ? 0 : 1, // 0 全部 1 自己
      spuId: spuId,
      pageIndex: configval.page,
      pageSize: configval.pageSize,
      dateTime: configval.time,
      rid
    }
    if (!hasMore && type === "down") return
    const toastContent = Toast.show({
      icon: "loading",
    });
    const { list, hasNext, size } = await getParticipationRecord(ccof)
    setHasMore(hasNext)
    if (type === "init") {
      setDataList(list ?? [])
    } else {
      setDataList(v => v.concat(list))
    }
    toastContent.close();
    setConfig(val => {
      val.total = size ?? 0
      return val
    })
  }
  const loadMore = async () => {
    if (!hasMore) { return }
    await getRecordData(rid, 'down', dayjs(viewTime).format('YYYY-MM'))
  }

  const onChangeTab = (type: ChangeType) => {
    setTabVal(() => type)
    getRecordData(rid, 'init', dayjs(viewTime).format('YYYY-MM'), type)
  }

  const onTimeChange = (v: PickerDate) => {
    setViewTime(v)
    getRecordData(rid, 'init', dayjs(v).format('YYYY-MM'))
  }
  const getViewDate = () => {
    let month = viewTime.getMonth()
    month = month >= 10 ? month : month + 1
    return viewTime.getFullYear() + '年' + month + '月'
  }
  const goToBlockChain = (id: string) => {
    navigate(`/welfare/blockchain?id=${id}&type=participant`)
  }
  return <div className={styles.records}>
    <div className={styles['records-wrap']}>
      <div className={styles['records-project']} style={{ color: WelfareColor[categoryId as WelfareMoldTyp]['titleColor'] }}>
        <span className={styles['records-project-num']}>{config.total}</span>
        <span>{`人已支持${projectName}`}</span>
      </div>
      <div className={styles['records-filter']}>
        <div className={styles['records-filter-lf']}>
          <div className={classnames(styles['records-filter-lf-all'], tabVal === 'all' ? styles.active : '')} onClick={onChangeTab.bind(this, 'all')} >全部</div>
          <div className={classnames(styles['records-filter-lf-own'], tabVal === 'own' ? styles.active : '')} onClick={onChangeTab.bind(this, 'own')} >只看我的</div>
        </div>
        <div className={styles['records-filter-rf']}>
          <div className={styles["records-filter-rf-time"]} onClick={() => setPickerVisible(true)}>
            <span>{getViewDate()}</span>
            <Image src={arrow_right_gray_icon} className={styles["records-filter-rf-time-icon"]} />
          </div>
          <DatePicker
            precision='month'
            visible={pickerVisible}
            onClose={() => setPickerVisible(false)}
            max={new Date()}
            min={minDate}
            onConfirm={onTimeChange}
          />
        </div>
      </div>
      {dataList.length > 0 ? <>
        <div className={styles.list}>
          {dataList.map((item, index) => (
            <div className={styles.items} key={item.id} onClick={goToBlockChain.bind(this, item.id)}>
              <div className={styles["items-info"]}>
                <img className={styles["items-info-img"]} src={item.headImg} alt="" />
                <div className={styles["items-info-name"]}>{item.userName}</div>
              </div>
              <div>{item.participateType}</div>
              <div className={styles['items-date']}>
                <span>{dayjs(item.date).format('YYYY-MM-DD')}</span>
                <Image src={arrow_right_gray_icon} className={styles["items-date-icon"]} />
              </div>
            </div>
          ))}
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} children={() => (<div />)} />
        </div>
      </> : <Empty description='暂无数据' />}
    </div>
    <div className={styles['records-bottom']}>
      <Image src={WelfareColor[categoryId as WelfareMoldTyp]['bottomSrc']} className={styles['records-bottom-img']} />
    </div>
    <SafeArea position='bottom' />
  </div>
}
export default Participant
